export const RF_MODEL_VERSION = '0.2.0';

export function freeSpacePathLossDb(frequencyGHz: number, distanceKm: number): number {
  if (frequencyGHz <= 0 || distanceKm <= 0) throw new RangeError('Frequency and distance must be positive');
  return 92.45 + 20 * Math.log10(frequencyGHz) + 20 * Math.log10(distanceKm);
}

export function fresnelRadiusM(frequencyGHz: number, distanceFromAM: number, distanceToBM: number): number {
  if (frequencyGHz <= 0 || distanceFromAM < 0 || distanceToBM < 0 || distanceFromAM + distanceToBM === 0) {
    throw new RangeError('Invalid Fresnel parameters');
  }
  const wavelengthM = 299_792_458 / (frequencyGHz * 1e9);
  return Math.sqrt((wavelengthM * distanceFromAM * distanceToBM) / (distanceFromAM + distanceToBM));
}

export function earthCurvatureBulgeM(distanceFromAM: number, distanceToBM: number, kFactor = 4 / 3): number {
  if (kFactor <= 0) throw new RangeError('K-factor must be positive');
  return (distanceFromAM * distanceToBM) / (2 * 6_371_000 * kFactor);
}

export { analyzeLineOfSight } from './los.js';
export type { CriticalPoint, LosAnalysisInput, LosDiagnostics, LosInputSample, LosProfileSample } from './los.js';
export { calculateLinkBudget } from './link-budget.js';
export type { LinkBudgetInput, LinkBudgetResult, McsEntry, RadioPerformanceProfile } from './link-budget.js';
export { rainSpecificAttenuation } from './rain.js';
export type { Polarization, RainfallProvider, RainSpecificAttenuation, RainSpecificAttenuationInput } from './rain.js';
export { optimizeAntennaHeights } from './height-optimizer.js';
export type { HeightOptimizationInput, HeightOptimizationMode, HeightOptimizationResult } from './height-optimizer.js';
export { antennaDirectionalGainDbi, antennaEngineeringReady, approximatePatternAttenuation, interpolateRadiationPattern, lifecycleEligibleForRecommendation, radioAntennaCompatible, radioEngineeringReady, recommendEquipment } from './equipment.js';
export type { EquipmentRecommendation, EquipmentRecommendationInput } from './equipment.js';
export { calculateCoverageMatrix, coverageDirectionalGainControl, NO_COVERAGE_DBM } from './coverage.js';
export type { CoverageCalculationInput, CoverageCalculationResult } from './coverage.js';
export { classifyClientAvailability, rankAccessPointCandidates } from './client-selection.js';
export { calculateInterferenceMatrix, calculatePlannedInterference, channelOverlapFraction } from './interference.js';
export type { InterferenceMatrixInput, InterferenceMatrixResult, InterferencePair, InterferenceSector, NetworkInterferenceResult, SectorInterferenceSummary } from './interference.js';
